import { useState, useEffect } from "react";
import { getLocations, createLocation, deleteLocation } from "../api/dashboardAPI";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Loader from "../components/Loader";
import Modal from 'react-modal';

import { deleteIcon, closeModalIcon, plusIcon, infoIcon } from "../components/Icons";
import { languages } from "../components/Constants";

const Locations = () => {

  const { token } = useSelector((state) => state.user);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  
  //Tooltip & Modal
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [locationIdToDelete, setLocationIdToDelete] = useState(0);
  const [locationNameToDelete, setLocationNameToDelete] = useState("");

  useEffect(() => {
    setLoading(true);
    getLocations(token).then((res) => {
      setLocations(res);
      setLoading(false);
    });
  }, [token]);

  const handleCreateClick = (e) => {
    e.preventDefault();
    setLoading(true);
    const formDataInput = new FormData(e.currentTarget);
    const data = new FormData();
    const groupedData = {};
    
    for (const [key, value] of formDataInput.entries()) {
      if (key !== "image") {
        const baseKey = key.split("_")[0];
        const language = key.split("_")[1];
        
        if (!groupedData[baseKey]) {
          groupedData[baseKey] = [];
        }
        
        groupedData[baseKey].push({
          text: value,
          language: language
        });
      }
    }
    
    Object.keys(groupedData).forEach(key => {
      data.append(key, JSON.stringify(groupedData[key]));
    });

    //Aggiungo il file immagine
    data.append('locationImage', e.currentTarget.image.files[0]);

    createLocation(token, data).then(() => {
      closeCreateModal(); 
      getLocations(token).then((res) => {
        setLocations(res);
        setLoading(false);
      });
    });
  };

  const handleDeleteLocationClick = (e, id) => {
    e.preventDefault();
    setLoading(true);
    deleteLocation(token, id).then(() => {
      closeDeleteModal(); 
      getLocations(token).then((res) => {
        setLocations(res);
        setLoading(false);
      });
    });
  };

  const openCreateModal = () => {
    setIsCreateModalOpen(true);
  };

  const closeCreateModal = () => {
    setIsCreateModalOpen(false);
  };

  const openDeleteModal = (id, name) => {
    setLocationIdToDelete(id);
    setLocationNameToDelete(name);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  return (
    <>
      <div className="flex items-center justify-between mb-4">
        <h1 className="font-bold text-xl">Lista località</h1>
        <div className="flex item-center gap-2">
          <button className="flex flex-cols-[auto_2fr] gap-1 bg-[#007474] rounded-xl pl-2 pr-2 h-8 cursor-pointer justify-center items-center text-xs transition duration-300 ease-in-out hover:bg-[#008585]" onClick={openCreateModal}>
            <div className="aspect-square w-6">{plusIcon}</div>
            <p>Aggiungi località</p>
          </button>
        </div>
      </div>
      
      {loading ? (
        <Loader />
      ) : (
        <table className="w-full bg-[linear-gradient(180deg,_rgba(1,74,74,0.70)_0%,rgba(20,20,20,1)_100%)] rounded-lg customShadow shadow-[#003333]">
          <thead>
            <tr className="border-b-2">
              <th className="pt-4 pb-4 pl-6 text-left" style={{width: "10%"}}>Nome</th>
              <th className="pt-4 pb-4 pl-6 text-left" style={{width: "10%"}}>Località</th>
              <th className="pt-4 pb-4 pl-6 text-left" style={{width: "10%"}}>Paese</th>
              <th className="pt-4 pb-4 pl-6 text-left" style={{width: "25%"}}>Descrizione località</th>
              <th className="pt-4 pb-4 pl-6 text-left" style={{width: "25%"}}>Descrizione punti interattivi</th>
              <th className="pt-4 pb-4 pl-6 text-left" style={{width: "25%"}}>Descrizione finale</th>
              <th className="pt-4 pb-4 pl-6 text-left" style={{width: "10%"}}></th>
              <th className="pt-4 pb-4 pl-6 text-left" style={{width: "10%"}}></th>
            </tr>
          </thead>
          <tbody>
            {locations && locations.length > 0 ? (
              locations.map((location) => (
                <tr key={location.id} >
                  <td className="pl-6 pr-6 pt-2 pb-2">{location.nome.translations[1].text}</td>
                  <td className="pl-6 pr-6 pt-2 pb-2">{location.localita.translations[1].text}</td>
                  <td className="pl-6 pr-6 pt-2 pb-2">{location.paese.translations[1].text}</td>
                  <td className="pl-6 pr-6 pt-2 pb-2">{location.descrizione.translations[1].text}</td>
                  <td className="pl-6 pr-6 pt-2 pb-2">{location.descrizione2.translations[1].text}</td>
                  <td className="pl-6 pr-6 pt-2 pb-2">{location.descrizioneFinale.translations[1].text}</td>
                  <td className="pl-6 pr-6 pt-2 pb-2" align="center">
                    <Link to={`/locations/${location.id}`}>
                      <button className="flex flex-cols-[auto_2fr] gap-1 bg-[#007474] rounded-xl pl-2 pr-2 h-8 cursor-pointer justify-center items-center text-xs transition duration-300 ease-in-out hover:bg-[#008585]" onClick={openCreateModal}>
                        <div className="aspect-square w-4">{infoIcon}</div>
                        <p>Dettagli</p>
                      </button>
                    </Link>
                  </td>
                  <td className="pl-6 pr-6 pt-2 pb-2" align="center">
                    <div className="flex align-center justify-center">
                      <button className="w-5 bg-[#007474] p-2 rounded-xl cursor-pointer justify-center items-center transition duration-300 ease-in-out hover:bg-[#008585]" onClick={() => openDeleteModal(location.id, location.nome.translations[0].text)} title="Elimina location">{deleteIcon}</button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7}>
                  <p className="p-4 text-center">
                    Nessuna località trovata
                  </p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}

      <Modal
          isOpen={isCreateModalOpen}
          onRequestClose={closeCreateModal}
          style={{
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
            },
          }}
          contentLabel="Aggiungi località"
        >
          <div className="bg-[#141414] h-full flex flex-col gap-4 p-6">
            <div className="flex w-full h-8 justify-between items-center">
              <p className="text-xl">Aggiungi località</p>
              <button className="aspect-square w-8 cursor-pointer transition duration-100 ease-in-out hover:scale-110" onClick={closeCreateModal}>{closeModalIcon}</button>
            </div>
            <div>
              <form className="flex flex-col gap-6" onSubmit={(e) => handleCreateClick(e)}>
                <div className="flex flex-col">
                  <p className="italic">Nome</p>
                  <div className="flex gap-4">
                    {languages.map((lang) => (
                      <div className="flex items-end gap-4">
                        <p>{lang.value.charAt(0).toUpperCase() + lang.value.slice(1)}:</p>
                        <input
                          className="bg-transparent border-b-2"
                          type="text"
                          name={"nome_" + lang.slug}
                        ></input>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col">
                  <p className="italic">Località</p>
                  <div className="flex gap-4">
                    {languages.map((lang) => (
                      <div className="flex items-end gap-4">
                        <p>{lang.value.charAt(0).toUpperCase() + lang.value.slice(1)}:</p>
                        <input
                          className="bg-transparent border-b-2"
                          type="text"
                          name={"localita_" + lang.slug}
                        ></input>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col">
                  <p className="italic">Paese</p>
                  <div className="flex gap-4">
                    {languages.map((lang) => (
                      <div className="flex items-end gap-4">
                        <p>{lang.value.charAt(0).toUpperCase() + lang.value.slice(1)}:</p>
                        <input
                          className="bg-transparent border-b-2"
                          type="text"
                          name={"paese_" + lang.slug}
                        ></input>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col">
                  <p className="italic">Descrizione località</p>
                  <div className="flex gap-4">
                    {languages.map((lang) => (
                      <div className="flex items-end gap-4">
                        <p>{lang.value.charAt(0).toUpperCase() + lang.value.slice(1)}:</p>
                        <input
                          className="bg-transparent border-b-2 w-full"
                          type="text"
                          name={"descrizione_" + lang.slug}
                        ></input>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col">
                  <p className="italic">Descrizione punti interattivi</p>
                  <div className="flex gap-4">
                    {languages.map((lang) => (
                        <div className="flex items-end gap-4">
                          <p>{lang.value.charAt(0).toUpperCase() + lang.value.slice(1)}:</p>
                          <input
                              className="bg-transparent border-b-2 w-full"
                              type="text"
                              name={"descrizione2_" + lang.slug}
                          ></input>
                        </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col">
                  <p className="italic">Descrizione finale</p>
                  <div className="flex gap-4">
                    {languages.map((lang) => (
                      <div className="flex items-end gap-4">
                        <p>{lang.value.charAt(0).toUpperCase() + lang.value.slice(1)}:</p>
                        <input
                          className="bg-transparent border-b-2 w-full"
                          type="text"
                          name={"descrizioneFinale_" + lang.slug}
                        ></input>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex flex-col gap-2">
                  <p className="italic">Immagine</p>
                  <div className="flex gap-4">
                    <input
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      name="image"
                    ></input>
                  </div>
                </div>
                <div className="flex justify-center mt-2">
                  <button className="flex flex-cols-[auto_2fr] gap-1 bg-[#007474] rounded-xl pl-6 pr-6 h-8 text-xs cursor-pointer justify-center items-center transition duration-300 ease-in-out hover:bg-[#008585]">
                    <p>Conferma</p>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>

      <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          style={{
            content: {
              top: '50%',
              left: '50%',
              right: 'auto',
              bottom: 'auto',
              marginRight: '-50%',
              transform: 'translate(-50%, -50%)',
            },
          }}
          contentLabel="Elimina località"
        >
          <div className="bg-[#141414] h-full flex flex-col gap-4 p-6">
            <div className="flex w-full h-8 justify-between items-center">
              <p className="text-xl">Elimina località</p>
              <button className="aspect-square w-8 cursor-pointer transition duration-100 ease-in-out hover:scale-110" onClick={closeDeleteModal}>{closeModalIcon}</button>
            </div>
            <div>
              <form>
                <p>Sei sicuro di voler eliminare la località '{locationNameToDelete}'?</p>
                <div className="flex justify-center items-center gap-1 mt-3">
                  <button className="flex flex-cols-[auto_2fr] gap-1 bg-[#007474] rounded-xl pl-6 pr-6 h-8 text-xs cursor-pointer justify-center items-center transition duration-300 ease-in-out hover:bg-[#008585]" onClick={(e) => handleDeleteLocationClick(e, locationIdToDelete)}>
                    <p>Conferma</p>
                  </button>
                </div>
              </form>
            </div>
          </div>
      </Modal>
    </>
  );
};

export default Locations;
